<script setup lang="ts">
const menuItems = ['KGS', 'RUB', 'USD', 'EUR', 'KZT']
const currencyList = useCurrencyStore().list

const fitCurrencies = computed(() => {
  return currencyList
    .filter((i) => menuItems.includes(i.code))
    .map((i) => ({
      title: i.title,
      url: `/money-transfers/${i.code.toLowerCase()}`
    }))
})
</script>

<template>
  <SidebarBlock
    v-if="fitCurrencies.length"
    :heading-text="$t('widget.select_currency.heading')"
    variant="white"
  >
    <SidebarMenu :menu-items="fitCurrencies" />
  </SidebarBlock>
</template>
